export default __webpack_public_path__ + "static/media/template3.f7d7c28f.png";